var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"toggle-fullscreen",attrs:{"title":_vm.buildTitle},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{},[_c('i',{class:_vm.buildClass}),_vm._v(" "+_vm._s(_vm.buildTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }